import { Component, Input } from '@angular/core';
import { SmAssignableBadgeVM } from "../sm-assignable-badge/sm-assignable-badge.viewmodel";
import { AuroraAvatarUserInterface } from '@insurity/aurora-lit';

@Component({
    standalone: false,
    selector: 'unity-avatar',
    templateUrl: './unity-avatar.component.html',
    styleUrls: ['./unity-avatar.component.scss']
})
export class UnityAvatarComponent {
    @Input() model: SmAssignableBadgeVM;
    @Input() color: AvatarColor;
    @Input() image: String;
    @Input() state: 'enabled' | 'disabled' | 'pending' = 'enabled';
    @Input() size: 'small' | 'medium' | 'large' | 'xlarge' = 'medium';

    public auroraUser: AuroraAvatarUserInterface;
    public auroraCurrentColor: string;
    
    public currentColor: AvatarColor;

    ngOnInit() {
        this.currentColor = this.color;
        this.setColor();

        this.convertToAuroraUser();
    }

    ngOnChanges() {
        this.currentColor = this.color;
        this.setColor();

        this.convertToAuroraUser();
    }

    setColor() {
        // If the color was set explicitly, don't change it
        if (this.color)
            return;

        if (this.model?.IsCurrentUser) {
            this.currentColor = AvatarColor.Magenta;
            this.auroraCurrentColor = 'signal';
        } else if (this.model?.Initials && this.model?.Initials != "?"){
            this.currentColor = AvatarColor.Blue;
            this.auroraCurrentColor = 'charge';

        } else {
            // No user loaded, so make it grey
            this.currentColor = AvatarColor.Grey;
            this.auroraCurrentColor = 'vapor';
        }
    }

    convertToAuroraUser() {
        if (this.model) {
            this.auroraUser = {
                initials: this.model?.Initials,
                name: this.model?.Name,
                subline1: this.model?.Title,
                subline2: '',
                disabled: this.model?.Disabled,
                image: ''
            };
        }   
    }
}

export enum AvatarColor {
    Magenta = "magenta",
    Blue = "blue",
    Cyan = "cyan",
    Purple = "purple",
    Ultramarine = "ultramarine",
    Pink = "pink",
    Grey = "grey"
};